import { render } from "./HomeEleve.vue?vue&type=template&id=476f8954&scoped=true"
import script from "./HomeEleve.vue?vue&type=script&lang=js"
export * from "./HomeEleve.vue?vue&type=script&lang=js"

import "./HomeEleve.vue?vue&type=style&index=0&id=476f8954&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476f8954"]])

export default __exports__